var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "28", height: "27", viewBox: "0 0 28 27", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#clip0_2799_11244)" },
      React.createElement("path", { d: "M14.191 26.383c7.456 0 13.5-5.884 13.5-13.142 0-7.258-6.044-13.142-13.5-13.142C6.736.099.691 5.983.691 13.24c0 7.258 6.045 13.142 13.5 13.142z", fill: "#fff" }),
      React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.096 8.369a1.376 1.376 0 0 0-1.91 0 1.29 1.29 0 0 0 0 1.858l3.096 3.014-3.096 3.013a1.29 1.29 0 0 0 0 1.859 1.376 1.376 0 0 0 1.91 0l3.095-3.014 3.095 3.014a1.376 1.376 0 0 0 1.91 0 1.29 1.29 0 0 0 0-1.859L16.1 13.241l3.096-3.014a1.29 1.29 0 0 0 0-1.858 1.376 1.376 0 0 0-1.91 0l-3.095 3.013-3.095-3.013z", fill: "#D1D1D1" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "clip0_2799_11244" },
        React.createElement("path", { fill: "#fff", transform: "translate(.691 .099)", d: "M0 0h27v26.285H0z" })
      )
    )
  );
});